const AUTOMATED_USER_AGENT_PATTERN =
  /(?:bot|crawler|spider|slurp|google-inspectiontool|googleother|lighthouse|pagespeed|headlesschrome|prerender|facebookexternalhit|bingpreview)/i;

export function isAutomatedUserAgent(userAgent: unknown): boolean {
  const value = String(userAgent || '').trim();
  return Boolean(value) && AUTOMATED_USER_AGENT_PATTERN.test(value);
}

export function isAutomatedBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  return navigator.webdriver === true || isAutomatedUserAgent(navigator.userAgent);
}
